import React from 'react';
import { Outlet, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute/PrivateRoute';
import Dashboard from './Dashboard';
import RepScorecards from './RepScorecards/RepScorecards';
import NewPhysician from './NewPhysician/NewPhysician';
import TopMedications from './TopMedications/TopMedications';
import TopCities from './TopCities/TopCities';
import TopStates from './TopStates/TopStates';
import TopSpecializations from './TopSpecializations/TopSpecializations';
import TopPayors from './TopPayors/TopPayors';
import TopGroups from './TopGroups/TopGroups';
import TopPhysicians from './TopPhysicians/TopPhysicians';
import TopCopayNetworks from './TopCopayNetworks/TopCopayNetworks';
import GrowthBySpecializations from './GrowthBySpecializations/GrowthBySpecializations';
import TopHubs from './TopHubs/TopHubs';
import ReportSingle from './ReportSingle';
import SyncPakVsSortPak from './SyncPakVsSortPak/SyncPakVsSortPak';
import NoteCount from "./NoteCount/NoteCount";
import UnassignedPhysicians from "./UnassignedPhysicians/UnassignedPhysicians";

export const DashboardRoutes = (
  <Route path="dashboard" element={<Outlet />}>
    <Route
      index
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Health']}>
          <Dashboard />
        </PrivateRoute>
        )}
    />

    <Route
      path="rep-scorecards"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <RepScorecards />
        </PrivateRoute>
        )}
    />

    <Route
      path="user-workflow"
      element={(
        <PrivateRoute roles={['Admin']}>
          <RepScorecards workflow />
        </PrivateRoute>
        )}
    />

    <Route
      path="note-count"
      element={(
        <PrivateRoute roles={['Admin']}>
          <NoteCount />
        </PrivateRoute>
        )}
    />

    <Route
      path="unassigned-physicians"
      element={(
        <PrivateRoute roles={['Admin']}>
          <UnassignedPhysicians />
        </PrivateRoute>
        )}
    />

    <Route
      path="report-single"
      element={(
        <PrivateRoute roles={['Admin', 'Health']}>
          <ReportSingle />
        </PrivateRoute>
        )}
    />

    <Route
      path="new-physicians"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <NewPhysician />
        </PrivateRoute>
        )}
    />

    <Route
      path="growth-by-specializations"
      element={(
        <PrivateRoute roles={['Admin']}>
          <GrowthBySpecializations />
        </PrivateRoute>
        )}
    />

    <Route
      path="syncPak-vs-sortPak"
      element={(
        <PrivateRoute roles={['Admin', 'Health']}>
          <SyncPakVsSortPak />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-medications"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Health']}>
          <TopMedications />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-cities"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Health']}>
          <TopCities />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-state"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Health']}>
          <TopStates />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-specializations"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <TopSpecializations />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-payors"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Health']}>
          <TopPayors />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-groups"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <TopGroups />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-hubs"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <TopHubs />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-physicians"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Health']}>
          <TopPhysicians />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-copay-networks"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <TopCopayNetworks />
        </PrivateRoute>
        )}
    />
  </Route>
);
